export const getDownloadOrDefault = async (client, uuid, content) => {
    return {
        content,
        isDownloaded: false,
    };
};
//# sourceMappingURL=getDownloadOrDefault.web.js.map